import React, { Component } from 'react';
class Jscontentloader extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
                <div className="contentLoader jscontentLoader">
                    <div className="skeleton">
                        <div className="skeleton-wrapper">
                            <div className="skeleton-wrapper-inner">
                                <div className="skeleton-wrapper-body">
                                    <div className="skeleton-avatar js-avatar"></div>
                                    <div className="skeleton-author jsskeleton-author"></div>
                                    <div className="skeleton-label jsskeleton-label"></div>
                                    <div className="skeleton-content-1"></div>
                                    <div className="skeleton-content-2"></div>
                                    <div className="skeleton-content-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
    }
}export default Jscontentloader;


// WEBPACK FOOTER //
// ./src/components/bol/jscontentloader.js